import type {
  HeadersFunction,
  MetaFunction,
} from "@remix-run/cloudflare";
import { Link } from "@remix-run/react";
import clsx from "clsx";
import AboutBg1 from "~/assets/about_bg_1.png";
import AboutBg2 from "~/assets/about_bg_2.png";
import AboutBg3 from "~/assets/about_bg_3.png";
import { buttonBase } from "~/components/Common/FormStyle";
import {
  DEFAULT_DESCRIPTION,
  TITLE_SUFFIX,
} from "~/utils/const";
import { pricePlans } from "../select-plan";

export const meta: MetaFunction = () => {
  return [
    { title: "ABOUT" + TITLE_SUFFIX },
    {
      name: "description",
      content: DEFAULT_DESCRIPTION,
    },
  ];
};

export const headers: HeadersFunction = ({
  loaderHeaders,
}) => ({
  "op-cache-status":
    loaderHeaders.get("op-cache-status") ??
    "MISS",
});

export default function Index() {
  return (
    <div className={clsx("text-black")}>
      <div
        className={clsx(
          "pt-250",
          "relative",
          "pb-201",
          "max-md:pt-120",
          "max-md:pb-120",
        )}
      >
        <img
          className={clsx(
            "absolute",
            "top-0",
            "left-0",
            "w-full",
            "h-full",
            "object-cover",
            "z-[-1]",
          )}
          src={AboutBg1}
          alt=""
        />

        <div
          className={clsx(
            "w-1240",
            "mx-auto",
            "grid",
            "grid-cols-2",
            "max-md:w-340",
            "max-md:flex",
            "max-md:flex-col",
            "max-md:gap-60",
          )}
        >
          <h2
            className={clsx(
              "font-bold",
              "font-en",
              "text-96",
              "leading-[1]",
              "max-md:text-60",
            )}
          >
            What
            <br />
            Is
            <br />
            OURPR?
          </h2>
          <div
            className={clsx(
              "text-40",
              "pt-20",
              "max-md:text-24",
            )}
          >
            <h3 className={clsx("font-bold")}>
              全国300万の中小企業のための
              <br />
              PRプラットフォーム
            </h3>
            <p
              className={clsx(
                "mt-70",
                "text-17",
                "leading-[1.75]",
                "max-md:text-14",
              )}
            >
              OURPRは、全国300万あると言われる中小企業のためのPRプラットフォーム。「Public
              Relations」と「Profile
              Record」の２つの目的とし、企業(事業)活動をサポートします。安価で、安心、より気軽に行える企業コミュニケーションプラットフォームとしてご活用いただけます。
            </p>
            <div className={clsx("mt-72")}>
              <Link
                to="/create-account"
                className={clsx(buttonBase())}
              >
                登録希望の方はこちら
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div
        className={clsx(
          "pt-184",
          "relative",
          "pb-120",
          "max-md:pt-100",
          "max-md:pb-100",
        )}
      >
        <img
          className={clsx(
            "absolute",
            "top-0",
            "left-0",
            "w-full",
            "h-full",
            "object-cover",
            "z-[-1]",
          )}
          src={AboutBg2}
          alt=""
        />

        <div
          className={clsx(
            "w-1240",
            "mx-auto",
            "grid",
            "grid-cols-2",
            "max-md:w-340",
            "max-md:flex",
            "max-md:flex-col",
            "max-md:gap-60",
            "max-md:flex-col-reverse",
          )}
        >
          <div
            className={clsx(
              "flex",
              "flex-col",
              "gap-50",
              "pl-60",
              "max-md:pl-0",
            )}
          >
            {[
              {
                head: "広報・発信を促進する<br/>Public Relations",
                desc: "自分たちの取り組みや想いを社会に届け、共感や関係性を広げる発信の手段。OURPRでは、応援スタンプやフォローによって、温度感のある広報活動が誰でも気軽に行えます。",
              },
              {
                head: "第二の企業サイトとなる<br/>Profile Record",
                desc: "単なる活動ログではなく、企業や個人のストーリー、想いや選択の積み重ねが記録されていく場。PRを「伝える」だけでなく、「残していく」ことで信頼と文脈を育てるプロフィール資産を貯めていく場として活用します。",
              },
            ].map((el, index) => {
              return (
                <div
                  className={clsx(
                    "flex",
                    "items-start",
                    "gap-30",
                    index !== 0 && "ml-100",
                    "w-470",
                    "max-md:w-full",
                    "max-md:ml-0",
                  )}
                >
                  <div
                    className={clsx(
                      "text-110",
                      "font-en",
                      "font-bold",
                      "leading-[1]",
                      "pt-20",
                      "max-md:text-80",
                    )}
                  >
                    {index + 1}.
                  </div>
                  <div className={clsx()}>
                    <h3
                      className={clsx(
                        "font-bold",
                        "text-32",
                        "max-md:text-20",
                      )}
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: el.head,
                        }}
                      />
                    </h3>
                    <div
                      className={clsx(
                        "text-17",
                        "leading-[1.75]",
                        "mt-30",
                        "max-md:text-14",
                      )}
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: el.desc,
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <h2
            className={clsx(
              "font-bold",
              "font-en",
              "text-96",
              "leading-[1.2]",
              "text-right",
              "max-md:text-60",
            )}
          >
            The
            <br />
            Meaning
            <br />
            Behind
            <br />
            ”PR”
          </h2>
        </div>
      </div>

      <div
        className={clsx(
          "pt-104",
          "relative",
          "pb-157",
          "max-md:pt-100",
          "max-md:pb-100",
        )}
      >
        <img
          className={clsx(
            "absolute",
            "top-0",
            "left-0",
            "w-full",
            "h-full",
            "object-cover",
            "z-[-1]",
          )}
          src={AboutBg3}
          alt=""
        />

        <div
          className={clsx(
            "w-1240",
            "mx-auto",
            "grid",
            "grid-cols-2",
            "max-md:w-340",
            "max-md:w-340",
            "max-md:flex",
            "max-md:flex-col",
            "max-md:gap-60",
          )}
        >
          <h2
            className={clsx(
              "font-bold",
              "font-en",
              "text-96",
              "leading-[1]",
              "max-md:text-60",
            )}
          >
            Social
            <br />
            Pricing
          </h2>
          <div
            className={clsx(
              "text-40",
              "pt-20",
              "max-md:text-24",
            )}
          >
            <h3 className={clsx("font-bold")}>
              使い続けやすい価格と
              <br />
              ソーシャルプライシング
            </h3>
            <p
              className={clsx(
                "mt-10",
                "text-17",
                "leading-[1.75]",
                "max-md:text-14",
              )}
            >
              OURPRは利用者の属性により、価格が変わる「ソーシャル・プライシング」を採用しています。まず、NPOやNGOといった社会的な活動をされている団体は無料です。フリーや個人で活動される方、もしくや個人商店の方などは550円。大企業は5500円といったように、それぞれの活動領域やフェーズによって価格を変えていきます。
            </p>
          </div>
        </div>
        <div
          className={clsx(
            "w-840",
            "mx-auto",
            "grid",
            "grid-cols-3",
            "gap-20",
            "mt-80",
            "max-md:w-300",
            "max-md:grid-cols-1",
            "max-md:gap-30",
          )}
        >
          {pricePlans.map((plan) => (
            <div
              key={plan.id}
              className={clsx(
                "bg-white",
                "rounded-[1rem]",
                "pt-70",
                "pb-70",
                "text-center",
              )}
            >
              <h3
                className={clsx(
                  "font-medium",
                  "text-24",
                  "whitespace-nowrap",
                )}
              >
                {plan.name}
              </h3>
              <p
                className={clsx(
                  "mt-20",
                  "text-12",
                  "leading-[1.5]",
                )}
                dangerouslySetInnerHTML={{
                  __html: plan.desc,
                }}
              ></p>
              <div
                className={clsx(
                  "mt-30",
                  "font-bold",
                  "text-32",
                  "font-en",
                )}
              >
                {plan.price === 0
                  ? "FREE"
                  : `¥${plan.price.toLocaleString()}/月`}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
